import {
  LayoutDashboard, Users, Inbox, Key, Globe, BadgeCheck, Video, Flag,
  MessageSquare, Calendar, Megaphone, Film, BookOpen, Bug, MessageSquareText,
} from 'lucide-react';

// The admin console's sections. `min` is the lowest app_role that sees the
// entry; each screen and every RPC behind it enforce the same thing, so this
// only decides what is SHOWN. `countKey` names a field of useAdminSummary.
//
// Member management is admin+ (050); tables and sign-ups were already admin+
// server-side (040, 037).
export const ADMIN_RANK = { moderator: 1, admin: 2, superadmin: 3 };

export const ADMIN_NAV = [
  { group: null, items: [
    { path: '/admin', label: 'Overview', icon: LayoutDashboard, min: 'moderator', end: true },
  ] },
  { group: 'People', items: [
    { path: '/admin/members', label: 'Members', icon: Users, min: 'admin' },
    { path: '/admin/signups', label: 'Sign-ups', icon: Inbox, min: 'admin', countKey: 'newSignups' },
    { path: '/admin/codes', label: 'Invite codes', icon: Key, min: 'moderator' },
    { path: '/admin/domains', label: 'Agency domains', icon: Globe, min: 'moderator' },
  ] },
  { group: 'Moderation', items: [
    { path: '/admin/verification', label: 'Verification', icon: BadgeCheck, min: 'moderator', countKey: 'verification' },
    { path: '/admin/videos', label: 'Video queue', icon: Video, min: 'moderator', countKey: 'videos', urgentKey: 'videosUrgent' },
    { path: '/admin/reports', label: 'Reports', icon: Flag, min: 'moderator', countKey: 'reports' },
    { path: '/admin/feedback', label: 'Feedback', icon: MessageSquareText, min: 'moderator' },
  ] },
  { group: 'Content', items: [
    { path: '/admin/tables', label: 'Tables', icon: MessageSquare, min: 'admin' },
    { path: '/admin/events', label: 'Events', icon: Calendar, min: 'moderator' },
    { path: '/admin/announcements', label: 'Announcements', icon: Megaphone, min: 'moderator' },
    { path: '/admin/curated-videos', label: 'Curated videos', icon: Film, min: 'moderator' },
    { path: '/admin/bookshelf', label: 'Bookshelf', icon: BookOpen, min: 'moderator' },
  ] },
  // Admin+: rows carry member ids (062).
  { group: 'System', items: [
    { path: '/admin/errors', label: 'App errors', icon: Bug, min: 'admin' },
  ] },
];

export function canSee(appRole, min) {
  return (ADMIN_RANK[appRole] || 0) >= ADMIN_RANK[min];
}
